import { AfterViewInit, Renderer2, ElementRef, HostBinding, HostListener, Component, inject } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * Popup Interface
 */
export declare interface Popup {
    saving?: boolean;

    /**
     * Subject
     */
    closeSubject: Subject<string>;

    /**
     * Event
     */
    closeEvent: Observable<string>;

    /**
     * Passed Data
     */
    data: unknown;

    /**
     * Set Data
     */
    setData?(data: unknown): void;
}

/**
 * Popup Absctract Class
 */
@Component({
    selector: 'app-popup-base',
    template: '',
})
export abstract class PopupBaseComponent implements Popup, AfterViewInit {
    public renderer2 = inject(Renderer2);
    public elementRef = inject(ElementRef);

    blockEsc = false;

    /**
     * Saving flag
     */
    saving?: boolean;

    /**
     * Data
     */
    data: unknown;

    /**
     * Subject
     */
    closeSubject = new Subject<string>();

    /**
     * Event
     */
    get closeEvent(): Observable<string> {
        return this.closeSubject.asObservable();
    }

    /**
     * Animation host binding
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    @HostBinding('@openClose') get(): void {}

    /**
     * Listen to escape keypress - close if not saving
     */
    @HostListener('document:keydown.escape')
    onKeydownHandler(): void {
        if (this.saving === true) {
            return;
        }
        if (this.blockEsc === true) {
            return;
        }
        this.closeSubject.next('key.escape');
    }

    ngAfterViewInit(): void {
        // get main element

        const mainElement: unknown = this.elementRef.nativeElement.children[0];

        // create wrap element
        const wrapElement: unknown = this.renderer2.createElement('div');
        // add classes
        this.renderer2.addClass(wrapElement, 'popup-overlay');
        this.renderer2.addClass(wrapElement, 'inner');
        this.renderer2.addClass(wrapElement, 'bg-white');
        this.renderer2.addClass(wrapElement, 'rounded');
        this.renderer2.addClass(wrapElement, 'relative');
        this.renderer2.addClass(wrapElement, 'border');
        this.renderer2.addClass(wrapElement, 'border-gray-200');

        // wrap

        this.renderer2.removeChild(this.elementRef.nativeElement, this.elementRef.nativeElement.children[0]);
        this.renderer2.appendChild(wrapElement, mainElement);
        this.renderer2.appendChild(this.elementRef.nativeElement, wrapElement);
    }

    /**
     * Set Passed from parent data
     */
    setData(data: unknown): void {
        this.data = data;
    }
}
